import apiWorker from '../apiWorker'

const credit_purchases = {
    search : (company_id, data) =>  apiWorker('post', `/v1/admin/${company_id}/credit_purchases`, data),
    analyze : (company_id, month) =>  apiWorker('get', `/v1/admin/${company_id}/credit_purchases/analyze/${month}`),
}

export default credit_purchases;